import { Component } from '@angular/core';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ActiveIngredientService } from '../../active-ingredient.service';
import {
  ACTIVE_INGREDIENT_TTL_ES,
  IActiveIngredient
} from '../../active-ingredient.interface';

@Component({
  selector: 'pg-active-ingredient',
  templateUrl: './active-ingredient.component.html'
})
export class ActiveIngredientComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private serviceBase: ActiveIngredientService) {
    super(ACTIVE_INGREDIENT_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: ACTIVE_INGREDIENT_TTL_ES,
      columns: [{ header: 'Descripción', field: 'description' }]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IActiveIngredient[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
